import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'componentes/common/Flex.js';
import IconButton from 'componentes/common/IconButton.js';
import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FormatDate, FormatDateFull } from 'helpers/FormatData.js';
import SubtleBadge from 'componentes/common/SubtleBadge.js';
import { statusIcons } from 'helpers/GetIcons.js';

const QuejaHeader = ({
  queja,
  isOpen,
  isAdmin,
  setOpenModalReOpen,
  setOpenModalCierre,
  setOpenModalConsumidor,
  confirmDeleteQueja
}) => {
  const maxFecha =
    queja.seguimientoquejas && queja.seguimientoquejas.length > 0
      ? queja.seguimientoquejas.reduce((max, item) => {
          return new Date(item.fecha) > new Date(max.fecha) ? item : max;
        })
      : 'Sin seguimientos';
  return (
    <>
      <Card className="mb-3">
        <Card.Header>
          <Row className="g-2">
            <Col>
              <h5 className="mb-2">#{queja.numeroqueja}</h5>
            </Col>
            <Col xs="auto">
              <h4 className="text-uppercase text-800">
                <SubtleBadge
                  pill
                  bg={
                    statusIcons.find(
                      item => item.status === queja.status.descripcion
                    ).color
                  }
                  className="d-block text-700 mb-0"
                >
                  {queja.status.descripcion}
                </SubtleBadge>
              </h4>
            </Col>{' '}
            <Col xs="auto">
              <h4 className="text-uppercase text-800">
                {' '}
                {isAdmin && (
                  <IconButton
                    className="ms-2"
                    iconClassName="fs-11 me-1"
                    variant="falcon-default"
                    size="sm"
                    icon="check"
                    onClick={() => confirmDeleteQueja()}
                  >
                    Eliminar Queja
                  </IconButton>
                )}
                {queja.idstatus != 12 && (
                  <IconButton
                    className="ms-2"
                    iconClassName="fs-11 me-1"
                    variant="falcon-default"
                    size="sm"
                    icon="check"
                    onClick={() => setOpenModalReOpen()}
                  >
                    Reabrir Queja
                  </IconButton>
                )}
                {isOpen && (
                  <IconButton
                    className="ms-2"
                    iconClassName="fs-11 me-1"
                    variant="falcon-default"
                    size="sm"
                    icon="check"
                    onClick={() => setOpenModalCierre(true)}
                  >
                    Cierre de Queja
                  </IconButton>
                )}
              </h4>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="border-top">
          <Row>
            <Col>
              <Flex>
                <FontAwesomeIcon
                  icon="user"
                  className="text-success me-2"
                  transform="down-5"
                />
                <div className="flex-1">
                  <IconButton
                    className="  me-1 mb-1"
                    variant="light"
                    size="sm"
                    icon="pencil-alt"
                    iconAlign="left"
                    onClick={() => setOpenModalConsumidor(true)}
                  >
                    {queja.nombreconsumidor}
                  </IconButton>
                </div>
              </Flex>
            </Col>
            <Col>
              <Row>
                <Flex>
                  <p className="mb-0">Fecha de Queja</p>
                </Flex>
              </Row>
              <Row>
                <Flex>
                  <div className="flex-1">
                    <p className="mb-0"> {FormatDate(queja.fechaqueja)}</p>
                  </div>
                </Flex>
              </Row>
            </Col>
            <Col>
              <Row>
                <Flex>
                  <p className="mb-0">
                    {isOpen ? 'Proxima' : 'Ultima'} Audiencia
                  </p>
                </Flex>
              </Row>
              <Row>
                <Flex alignItems={'center'}>
                  <div className="flex-1 center">
                    <Badge
                      bg={isOpen ? 'primary' : 'secondary'} //isOpen ? 'secondary' : }
                      className="me-2"
                    >
                      {FormatDateFull(maxFecha.fecha)}
                    </Badge>
                  </div>
                </Flex>
              </Row>
            </Col>
          </Row>
          <Row>
            <hr />
          </Row>
          <Row>
            <Col>
              <Row>
                <div className="flex-1">
                  <h6 className="  i"> MOTIVO DE QUEJA</h6>
                </div>
              </Row>
              <Row>
                <div className="flex-1">
                  <p className="fw-bold i"> {queja.motivoqueja}</p>
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <div className="flex-1">
                  <h6 className="  i"> Telefono</h6>
                </div>
              </Row>
              <Row>
                <div className="flex-1">
                  <p className="fw-bold i"> {queja.tel1}</p>
                </div>
              </Row>
            </Col>
            <Col>
              <Row>
                <div className="flex-1">
                  <h6 className="  i">Email</h6>
                </div>
              </Row>
              <Row>
                <div className="flex-1">
                  <p className="fw-bold i"> {queja.email}</p>
                </div>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
QuejaHeader.propTypes = {
  queja: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  isAdmin: PropTypes.bool,
  setOpenModalReOpen: PropTypes.func,
  setOpenModalCierre: PropTypes.func,
  setOpenModalConsumidor: PropTypes.func,
  confirmDeleteQueja: PropTypes.func
};

export default QuejaHeader;
